<script setup lang="ts">
import {
	NavigationMenuList,
	NavigationMenuRoot,
	useForwardPropsEmits,
	type NavigationMenuRootEmits,
	type NavigationMenuRootProps,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

defineOptions({ inheritAttrs: false });

interface Props extends NavigationMenuRootProps, ClassProps {}

const props = withDefaults(defineProps<Props>(), { orientation: "vertical" });
const emit = defineEmits<NavigationMenuRootEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<NavigationMenuRoot v-bind="forwarded">
		<NavigationMenuList as="ul" :class="cn('menu w-full gap-1', props.class)" v-bind="$attrs">
			<slot />
		</NavigationMenuList>
	</NavigationMenuRoot>
</template>
